import {useState, useEffect} from 'react'
import {HgDisclaimer} from '~/design-system/hg/components'
import type {HgHeroProps} from '../../types'

type HeroDisclaimerProps = {
  disclaimer?: HgHeroProps['disclaimer']
}

export function Disclaimer({disclaimer}: HeroDisclaimerProps) {
  const [visible, setVisible] = useState(true)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 0) {
        setVisible(false)
      } else {
        setVisible(true)
        setHidden(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!disclaimer) return null

  return (
    <div
      data-visible={visible}
      aria-hidden={!visible && hidden}
      className="fixed bottom-0 left-0 right-0 z-[3] mx-s5 flex justify-center opacity-0 transition-[opacity] duration-300 aria-[hidden=true]:invisible data-[visible=true]:opacity-100"
      onTransitionEnd={() => {
        if (!visible) setHidden(true)
      }}
    >
      <HgDisclaimer centered variant="contained" bottomSpacing="s5">
        {disclaimer}
      </HgDisclaimer>
    </div>
  )
}
